import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';
import type { FC } from 'react';

interface DynamicInputListProps {
  name: string;
  label: string;
  placeholder: string;
  buttonText: string;
  rules?: any[];
}

export const DynamicInputList: FC<DynamicInputListProps> = ({
  name,
  label,
  placeholder,
  buttonText,
  rules,
}) => {
  return (
    <Form.List name={name}>
      {(fields, { add, remove }) => (
        <Form.Item label={label}>
          <div className="flex gap-4 flex-wrap">
            {fields.map((field) => {
              const { key, ...restField } = field;
              return (
                <div key={key} className="flex flex-col gap-2">
                  <div className="flex items-center gap-2">
                    <Form.Item
                      key={key}
                      {...restField}
                      rules={rules}
                      className="mb-0"
                    >
                      <Input placeholder={placeholder} style={{ width: 180 }} />
                    </Form.Item>
                    <MinusCircleOutlined
                      className="text-red-500 cursor-pointer"
                      onClick={() => remove(field.name)}
                    />
                  </div>
                </div>
              );
            })}
            <Button
              style={{ width: 180 }}
              type="dashed"
              onClick={() => add()}
              icon={<PlusOutlined />}
            >
              {buttonText}
            </Button>
          </div>
        </Form.Item>
      )}
    </Form.List>
  );
};
